module.exports = __webpack_public_path__ + "img/2d.d329af14.png";